module.exports = __webpack_public_path__ + "img/2.015c8c07.jpg";